import app from 'flarum/common/app';
import Button from 'flarum/common/components/Button';
import MobileTabComponent from '../../common/components/MobileTabComponent';
import MobileTabSessionDropdown from './MobileTabSessionDropdown';
export default class ForumMobileTabSessionItem extends MobileTabComponent {
  view() {
    if (app.session.user) {
      return m(MobileTabSessionDropdown, null);
    }
    return m(Button, {
      className: "Button Button--link",
      icon: this.attrs.definition.icon,
      onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'))
    }, app.translator.trans('acpl-mobile-tab.lib.item.log_in'));
  }
}
flarum.reg.add('gitzaai-v2mobileui', 'forum/components/ForumMobileTabSessionItem', ForumMobileTabSessionItem);